// Shamelessly copied from Dev Hub
// https://github.com/fastly/Developer-Portal/blob/production/src/lib/components/on-this-page/on-this-page.js

import { mixins } from "@fastly/consistently"
import { useRef } from "react"
import styled, { css } from "styled-components"
import useScrollspy from "@utils/scrollspy"
import { MikanSpan } from "../Mikan"

const { paddingBlock, paddingInline } = mixins

/**
 * Item format is as follows:
 * {
 *   title: "Readable title",
 *   url: "#linkable",
 *   items: Item[] | undefined
 * }
 */

export const StyledNavContainer = styled.nav`
  ${(props) => {
    if (props.secondaryNav) {
      return `
        display: flex;
        background: var(--white);
        border-bottom: 1px solid var(--grey-30);
        position: --webkit-sticky;
        position: sticky;
        top: 81px;
        width: 100%;
        z-index: 10;
      `
    } else {
      return `
      --header-height: 64px;
      position: sticky;
      top: calc(var(--header-height) + 16px);
      overflow-x: hidden;
      max-height: 95vh;
      padding: 0.8em 0.5em 0 0.8em;
      `
    }
  }};
`
export const StyledNav = styled.ul`
  ${(props) => {
    if (props.secondaryNav) {
      return css`
        overflow-x: auto;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        ${paddingInline(0)}
        ${paddingBlock("1rem")}
        padding: 1rem;
      `
    } else {
      return `
      margin: 1em 0 0 0;
      padding: 0;
      list-style-type: none;
      & ul {
        margin-top: 0;
        margin-left: 1em;
      }
      `
    }
  }}
`
export const StyledNavItem = styled.li`
  ${(props) => {
    if (props.secondaryNav) {
      return `
      list-style-type: none;
      flex: 1 0 auto;

      &:first-child a,
      &:first-child button {
        padding-left: 0;
      }

      &:last-child a,
      &:first-child button {
        padding-right: 0;
      }

      & a,
      & button {
        background-color: inherit;
        border: none;
        color: ${props.active ? "var(--grey-90)" : "var(--grey-60)"};
        font: var(--text-sm);
        text-decoration: none;
        padding: 0 8px;

        @media (min-width: 544px) {
          padding: 0 16px;
        }
      }`
    } else {
      return `
      --border: #D8D8D8;
      border: ${props.active ? "1px solid var(--magenta) !important" : "1px solid var(--border)"};
      border-bottom: none;
      padding: 16px 24px;

      & a {
        display: block;
        text-decoration: none;
        color: var(--color-text);
      }

      &:first-of-type {
        border-radius: 8px 8px 0 0;
      }

      &:last-of-type {
        border-radius: 0 0 8px 8px;
        border-bottom: 1px solid var(--border);
      }
      `
    }
  }}
`

const StyledHeader = styled.div`
  color: var(--purple);
`

export const OnThisPage = ({ items, hideIntro, secondaryNav }) => {
  const currentItem = useScrollspy({ itemsInitializer: () => getItemIDs(items) })
  const activeElement = useRef(null)

  const renderItem = (item) => {
    const isActive = currentItem && getIDForItem(item) === currentItem.id

    return (
      <StyledNavItem secondaryNav={secondaryNav} ref={isActive ? activeElement : null} active={isActive} key={item.url}>
        <a href={item.url} aria-label={item.title}>
          <MikanSpan text={item.title} />
        </a>
        {item.items && <ul>{item.items.map((i) => renderItem(i))}</ul>}
      </StyledNavItem>
    )
  }

  return (
    <StyledNavContainer secondaryNav={secondaryNav}>
      {!hideIntro ? <StyledHeader>On this page:</StyledHeader> : null}
      <StyledNav secondaryNav={secondaryNav}>{items.map((i) => renderItem(i))}</StyledNav>
    </StyledNavContainer>
  )
}

const getIDForItem = (item) => (item.url ? item.url.slice(1) : null)

const getItemIDs = (items) => {
  const ids = []

  items.forEach((item) => {
    ids.push(getIDForItem(item))
    if (item.items) ids.push(...getItemIDs(item.items))
  })

  return ids
}

export default OnThisPage
